export const agentViolationListData = [
    {
      agent_name: "Alice Johnson",
      totalCalls: 210,
      hippa: 5,
      greetings: 3,
      verification: 2,
      callback: 4,
      closing: 20,
      topic_sense: 0
    },
    {
      agent_name: "Brian Smith",
      totalCalls: 58,
      hippa: 2,
      greetings: 1,
      verification: 3,
      callback: 2,
      closing: 12,
      topic_sense: 3
    },
    {
      agent_name: "Charlie Brown",
      totalCalls: 198,
      hippa: 4,
      greetings: 2,
      verification: 5,
      callback: 3,
      closing: 23,
      topic_sense: 0
    },
    {
      agent_name: "Diana Green",
      totalCalls: 167,
      hippa: 6,
      greetings: 4,
      verification: 3,
      callback: 5,
      closing: 28,
      topic_sense: 2
    },
    {
      agent_name: "Eve Harris",
      totalCalls: 35,
      hippa: 3,
      greetings: 2,
      verification: 4,
      callback: 1,
      closing: 14,
      topic_sense: 0
    },
    {
      agent_name: "Michael Lee",
      totalCalls: 100,
      hippa: 4,
      greetings: 3,
      verification: 3,
      callback: 2,
      closing: 16,
      topic_sense: 0
    },
    {
      agent_name: "Sarah Johnson",
      totalCalls: 49,
      hippa: 2,
      greetings: 2,
      verification: 2,
      callback: 2,
      closing: 13,
      topic_sense: 1
    },
    {
      agent_name: "Michael Williams",
      totalCalls: 120,
      hippa: 5,
      greetings: 4,
      verification: 2,
      callback: 3,
      closing: 16,
      topic_sense: 0
    },
    {
      agent_name: "Samantha Lee",
      totalCalls: 110,
      hippa: 3,
      greetings: 2,
      verification: 4,
      callback: 2,
      closing: 15,
      topic_sense: 2
    },
    {
      agent_name: "Michael Johnson",    
      totalCalls: 156,
      hippa: 4,
      greetings: 3,
      verification: 2,
      callback: 3,
      closing: 18,
      topic_sense: 0
    }
  ];
  